module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("6ijNy"))).then(() => parcelRequire('bMny1'));